"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
_export(exports, {
    HomeeError: function() {
        return HomeeError;
    },
    buildHomeeErrorOptions: function() {
        return buildHomeeErrorOptions;
    }
});
const _extends = require("@swc/helpers/_/_extends");
const _serializeerror = require("serialize-error");
let HomeeError = class HomeeError extends Error {
    toString() {
        return JSON.stringify((0, _serializeerror.serializeError)(this));
    }
    constructor(message, options){
        const parsedOptions = buildHomeeErrorOptions(options);
        super(message);
        this.name = 'HomeeError';
        var _parsedOptions_logLevel;
        this.logLevel = (_parsedOptions_logLevel = parsedOptions.logLevel) != null ? _parsedOptions_logLevel : 'error';
        this.statusCode = parsedOptions.statusCode;
        this.data = parsedOptions.data;
        if (parsedOptions.innerError) {
            this.innerError = (0, _serializeerror.serializeError)(parsedOptions.innerError, {
                maxDepth: 4
            });
        }
    }
};
function buildHomeeErrorOptions(...arr) {
    return arr.reduce((prev, options)=>{
        const previous = prev;
        if (!options) {
            return previous;
        }
        if (options instanceof Error) {
            return _extends._({}, previous, {
                innerError: options
            });
        }
        const o = options;
        if (o.data || o.innerError || o.statusCode || o.logLevel) {
            return _extends._({}, previous, o);
        }
        const out = _extends._({}, previous, {
            data: _extends._({}, previous.data, options)
        });
        return out;
    }, {});
}

//# sourceMappingURL=homee.error.js.map